<template>
    <div>
        <b-form @submit="onSubmit"> 
        <b-row>
            <b-col cols="12">    
                <div class="pull-right">
                    <b-button v-if="isFromMessage" v-b-modal.modalReactie variant="themecolor" size="m"><i class="fa fa-comment" aria-hidden="true"></i></b-button>
                </div>     

                <b-button @click="goToHome()" variant="transparent" size="sm" class="pull-left">
                    <font-awesome-icon icon="angle-left" size="2x" />
                </b-button>
                <h3 class="text-themecolor my-1">Document {{$route.params.documentId}} <span v-if="!isFromMessage && this.currentDocumentIndex !== -1">({{this.currentDocumentIndex + 1}} van {{documenten.length}})</span></h3>            
            </b-col>
        </b-row>
        <b-row>
            <b-col md="7">
                <b-row>
                    <b-col md="6" class="pl-0">
                        <b>Klant</b>
                    </b-col>
                    <b-col v-if="document.klant != null" md="6" class="pl-0 basetriggerdata">
                        {{document.klant.naam }}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" class="pl-0">
                        <b>Filename</b>
                    </b-col>
                    <b-col md="6" class="pl-0 basetriggerdata">
                        {{document.filename }}
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col md="6" class="pl-0">
                        <b>Trigger</b>
                    </b-col>
                    <b-col md="6" class="pl-0 basetriggerdata">
                        {{document.triggerId }}
                    </b-col>
                </b-row> 
                
        <b-tabs 
          card
          justified
          active-nav-item-class="tab-active"
          nav-class="tab-nav"
          content-class="tab-content-area">
        <!--content-class="mt-3" pills>-->
          <!-- TAB 1: Uitgelezen/Juiste waarde -->
          <b-tab title="Uitgelezen met AI" active>                
                <b-row>
                    <b-col md="3" class="pl-0">
                    </b-col>
                    <b-col md="3" class="pl-0">
                        <b>Uitgelezen waarde</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        <b>Juiste waarde</b>
                    </b-col>                                        
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Factuurnummer</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.invoiceNumber }}
                    </b-col>
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.factuurnummer"  ref='factuurnummer' />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Factuurdatum</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.invoiceDate }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0 invoice-date">
                            <!-- <b-input-group> -->
                                <!-- <b-form-input v-model="command.factuurdatum" ref='factuurdatum' /> -->
                                <datepicker class="form-control" v-model="command.factuurdatum" placeholder="dd-mm-yyyy" ref='factuurdatum' />
                                <validation element="first_test_date" :message="$t('validatie.geldigedatum1eproef')" />
                            <!-- </b-input-group> -->
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Totaalbedrag</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.totalAmount }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.totaalbedrag"  ref='totaalbedrag' type="number" step="any" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Kosten hoog</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.costHigh }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.kostenHoog"  ref='kostenhoog' type="number" step="any"/>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Kosten laag</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.costLow }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.kostenLaag"  ref='kostenlaag' type="number" step="any" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Kosten nul</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.costNull }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.kostenNul"  ref='kostennul' type="number" step="any" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Kosten verlegd</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.costMoved }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.kostenVerlegd"  ref='kostenverlegd' type="number" step="any"/>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>BTW hoog</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.vatHigh }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.btwHoog"  ref='btwhoog' type="number" step="any" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>BTW laag</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.vatLow }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.btwLaag"  ref='btwlaag' type="number" step="any"/>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Referentie</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.paymentReference }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.referentie"  ref='referentie' />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Kvknummer</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.kvK }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.kvK"  ref='referentie' />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Btwnummer</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.vatNumber }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.vatNumber"  ref='referentie' />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" class="pl-0">
                        <b>Iban</b>
                    </b-col>
                    <b-col md="3" class="pl-0">
                        {{aiinvoicedataitem.iban }}
                    </b-col>                    
                    <b-col md="6" class="pl-0">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <b-form-input v-model="command.iban"  ref='referentie' />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>                                                   
                <b-row>
                    <b-col md="6" class="pl-0"></b-col>
                    <b-col md="6" class="pl-0 mt-4 mb-4">
                        <b-button id="btn-save-trigger" size="md" type="submit"  variant="themecolor" >{{$t('buttons.feedbackversturen')}}</b-button>
                    </b-col>
                </b-row>
          </b-tab>

          <!-- TAB 2: Placeholder -->
          <b-tab title="Optionele regex">
            <div class="p-2">

                <b-row class="custom-margin">
                    <b-col v-if="commandRegexes.triggerId !== undefined && commandRegexes.triggerId !== ''" md="9" class="nopadding">         
                         <h2>Kopgegevens</h2>
                
                        <b-form-group label="Factuurnummer" label-for="input-formatter" class="mb-0" >
                            <MatchRegex ref="factuurnummer" :key="readCommand.regexFactuurnummer" :regex="commandRegexes.regexFactuurnummer" :testcontent="combinedTestContent" @onChange="onRegexChange('regexFactuurnummer', $event)" class="no-margin-left" :dropdown=true :options="options.factuurnummer" :regexFieldType="regexFieldTypeEnum.Numberic"/>
                        </b-form-group>                         
                        <b-form-group label="Factuurdatum" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                            <MatchRegex ref="factuurdatum" :key="readCommand.regexFactuurdatum" :regex="commandRegexes.regexFactuurdatum" :testcontent="combinedTestContent" @onChange="onRegexChange('regexFactuurdatum', $event)" @resultRegex='onHandleRegexResult($event,"regexFactuurdatum")' class="no-margin-left" :dropdown=true :options="options.factuurdatum" :tryMatchFirstOption=watchOptionsFactuurdatum :regexFieldType="regexFieldTypeEnum.Date" />
                        </b-form-group>

                        <b-form-group label="Referentie" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                            <MatchRegex ref="referentie" :key="readCommand.regexReferentie" :testcontent="combinedTestContent" :regex="commandRegexes.regexReferentie" :showRegexField=false @onChange="onRegexChange('regexReferentie', $event)" @resultRegex='onHandleRegexResult($event,"regexReferentie")' class="no-margin-left" />
                        </b-form-group>

                        <br/>
                        <h2>Bedragen</h2>

                        <b-form-group label="Totaalbedrag" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                            <MatchRegex ref="totaalbedrag" :key="readCommand.regexTotaalbedrag" :testcontent="combinedTestContent" :regex="commandRegexes.regexTotaalbedrag" @onChange="onRegexChange('regexTotaalbedrag', $event)" @resultRegex='onHandleRegexResult($event,"regexTotaalbedrag")' class="no-margin-left" :dropdown=true :options="options.totaalbedrag" :tryMatchFirstOption=watchOptionsTotaalbedrag />
                        </b-form-group>

                        <b-form-group label="BTW laag" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                            <MatchRegex ref="btwLaag" :key="readCommand.regexBtwLaag" :testcontent="combinedTestContent" :regex="commandRegexes.regexBtwLaag" @onChange="onRegexChange('regexBtwLaag', $event)" :dropdown=true :options="options.btwLaag" @resultRegex='onHandleRegexResult($event,"regexBtwLaag")' class="no-margin-left" />
                        </b-form-group>
                        <b-form-group label="BTW hoog" label-for="input-formatter" class="mb-0" label-class="mb-0">
                            <MatchRegex ref="btwHoog" :key="readCommand.regexBtwHoog" :testcontent="combinedTestContent" :regex="commandRegexes.regexBtwHoog" @onChange="onRegexChange('regexBtwHoog', $event)" :dropdown=true :options="options.btwHoog" @resultRegex='onHandleRegexResult($event,"regexBtwHoog")' class="no-margin-left" />
                        </b-form-group>

                        <b-form-group label="Kosten nul" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                            <MatchRegex ref="kostenNul" :key="readCommand.regexKostenNul" :testcontent="combinedTestContent" :regex="commandRegexes.regexKostenNul" @onChange="onRegexChange('regexKostenNul', $event)" :dropdown=true :options="options.kostenNul" @resultRegex='onHandleRegexResult($event,"regexKostenNul")' class="no-margin-left" />
                        </b-form-group>

                        <b-form-group label="Kosten verlegd" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                            <MatchRegex ref="kostenVerlegd" :key="readCommand.regexKostenVerlegd" :testcontent="combinedTestContent" :regex="commandRegexes.regexKostenVerlegd" @onChange="onRegexChange('regexKostenVerlegd', $event)" @resultRegex='onHandleRegexResult($event,"regexKostenVerlegd")' :dropdown=true :options="options.kostenVerlegd" class="no-margin-left" />
                        </b-form-group>

                        <b-form-group v-if="renderKostenLaag" label="Kosten laag" label-for="input-formatter" class="mb-0" label-class="mb-0">
                            <MatchRegex  ref="kostenLaag" :key="readCommand.regexKostenLaag" :testcontent="combinedTestContent" :regex="commandRegexes.regexKostenLaag" @onChange="onRegexChange('regexKostenLaag', $event)" @resultRegex='onHandleRegexResult($event,"regexKostenLaag")' :dropdown=true :options="options.kostenLaag" class="no-margin-left" />
                        </b-form-group>

                        <b-form-group v-if="renderKostenHoog" label="Kosten hoog" label-for="input-formatter" class="mb-0" label-class="mb-0">
                            <MatchRegex ref="kostenHoog" :key="readCommand.regexKostenHoog" :testcontent="combinedTestContent" :regex="commandRegexes.regexKostenHoog" @onChange="onRegexChange('regexKostenHoog', $event)" @resultRegex='onHandleRegexResult($event,"regexKostenHoog")' :dropdown=true :options="options.kostenHoog" class="no-margin-left" />
                        </b-form-group>
                
                        <br/>
                        <b-button id="btn-save-regexes" type="button" size="sm" variant="themecolor" :disabled="disableButton" @click="saveRegexes">Opslaan</b-button>

                   </b-col>
                </b-row>
            </div>
          </b-tab>
        </b-tabs>                
                <b-row class="pl-0 mt-4" />
                <b-row>
                    <b-col md="6" class="pl-0">
                        <b>Filecontent</b>
                    </b-col>
                    <b-col md="6" class="pl-0">
                        <Readmore :text="document.filecontent" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" class="pl-0">
                        <b>Pdfcontent</b>
                    </b-col>
                    <b-col md="6" class="pl-0">
                        <Readmore :text="document.pdfcontent" />
                    </b-col>
                </b-row>                
            </b-col>             
            <b-col md="5">            
                <div v-if="statusCode" class="alert alert-danger">
                    {{statusCode}}: {{notFoundError}}
                </div>
                <div v-else>
                    <div v-if="!isImageLoaded">
                        <PreLoader/>
                    </div>
                    <b-card v-if="isImageLoaded">
                        <v-zoomer><img :src="'data:image/jpeg;base64,'+ image" class="w-100 h-100" :class="{ edit : document.isEdited == 1 }" /></v-zoomer>
                    </b-card>
                </div>      
            </b-col>
        </b-row>
        </b-form>
        <b-modal id="modalReactie" ref="priceagreements" :title="`Melding`" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
            <b-form autocomplete="off">
                <b-textarea id="reactie" :value="melding" type="text" />
            </b-form>
        </b-modal>        
    </div>
</template>
<script>
//Import store
import MatchRegex from '@/components/fmmanagement/MatchRegex.vue'
import { mapGetters, mapActions } from 'vuex'
import Command from '../documents/command'
import CommandRegexes from '../mltriggers/command'
import PreLoader from '@/components/root/Preloader';
import Readmore from '../../../../components/controls/Readmore.vue';
import RegexFieldTypeEnum from "@/enums/modules/RegexFieldType";

export default {
    name: 'document-detail',
    components: {MatchRegex,PreLoader, Readmore},
    props: [ 'isFromMessage', 'melding' ],
    data() {
        return {
            commandRegexes: new CommandRegexes(),
            command: new Command(),
            readCommand: new CommandRegexes(), 
            renderKostenLaag: true,
            renderKostenHoog: true,
            options: { factuurnummer: [], factuurdatum: [], totaalbedrag: [], subtotaal: [], btwLaag: [], btwHoog: [], kostenNul: [], kostenVerlegd: [], kostenLaag: [], kostenHoog:[]},           
            image: '',
            triggersearch: '',
            isImageLoaded: false,
            initializingRegexTab: true,
            disableButton: true,
            previous: 0,
            next: 0,
            message: '',
            meldingid: 0,
            currentDocumentIndex: 0,
            watchOptionsFactuurnummer: false,
            watchOptionsFactuurdatum: false,
            watchOptionsTotaalbedrag: false,
            watchOptionsSubtotaal: false,
            regexFieldTypeEnum: RegexFieldTypeEnum
        }
    },
    computed: {
        ...mapGetters('fmmodule',['document', 'trigger', 'triggers', 'mltriggers', 'mltrigger', 'documenten','triggermeldingen','aiinvoicedata','aiinvoicedataitem']),
        ...mapGetters('errors', ['statusCode', 'notFoundError']),

        commandProps() {
            return this.command
        },

        combinedTestContent() {
            const document = this.document || {}
            const fileContent = document.filecontent || ''
            const pdfContent = document.pdfcontent || ''

            return fileContent + '\n\n' + pdfContent
        }         
    },
    methods: {
        ...mapActions('fmmodule',['find','findFor','update','executeCommand','getImage','errors']),
        goToHome()
        {
            if (this.isFromMessage) {
                this.$router.push({ name: `triggermeldingen:index`, params: { triggerId: this.command.triggerId, triggermeldingId: this.meldingid }});
            }
            else {
                this.$router.push({ name: `documents:index`});   
            }
               
        },
        onSubmit(event) {
            event.preventDefault();
            var vm = this;
            vm.SendFeedback();
        },
        saveRegexes(event) {
            event.preventDefault();
            var vm = this;
            vm.SaveRegexes();            
        },
        onHandleRegexResult() {
        },
        onRegexChange(field, value) {
            this.commandRegexes[field] = value;

            if (!this.initializingRegexTab) {
                this.disableButton = false;
            }
        },        
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `documenten:${name}` });
        },
        loadImage()
        {
            var vm = this;
            vm.$store.dispatch('errors/clearErrors');
            vm.getImage(
                {
                    resource:"images",
                    filename: vm.document.filename
                }
                ).then((response) => {
                    this.isImageLoaded = true
                    this.image = response;
                }  )
        },
        SendFeedback()
        {
            var vm = this;   
            vm.command.id = this.$route.params.triggermelding != null ? this.$route.params.triggermelding.id : ''
            vm.command.triggerId = this.$route.params.triggermelding != null ? this.$route.params.triggermelding.triggerId : ''
            var payload = {
                    resource: "triggermeldingen/feedback",
                    params: vm.command
                };           
            vm.executeCommand(payload)
            .then(() => {
                this.goToHome();                
            })
            .catch(() => {          
            });
        },   
        SaveRegexes()
        {
            var vm = this;  
            
            vm.commandRegexes.documentId = vm.document.documentId;
            vm.commandRegexes.testcontent = vm.document.filecontent;
            vm.commandRegexes.testfilename = vm.document.filename;

            var payload = {
                    resource: "mltriggers",
                    params: vm.commandRegexes
            };  
            
            vm.update(payload)
            .then(() => {
                this.goToHome();                
            })
            .catch(() => {          
            });
        },
        async getDropdownItems(column)
        {
            var vm = this;
            await vm.executeCommand({resource: 'triggers/getTopFive?column=' + column})
                     .then((data) => {                   
                        this.options[column] = data.split("|||")
                    }).catch(() => {
                        vm.$swal("Er is iets verkeerd gegaan bij ophalen DropDown items, probeer het opnieuw");
                    });
        }
     
    },
    async created() {
        var vm = this;
        this.message = this.$route.params.melding;
        this.meldingid = this.$route.params.triggermelding.id;
        
        vm.command.copyTriggermelding(this.$route.params.triggermelding);
        vm.command.requestId = this.$route.params.triggermelding.document.aiRecognitionId

        vm.find({
            resource: 'documenten',
            id: this.$route.params.documentId
        })
        .then(() => {
            this.loadImage();

            this.currentDocumentIndex = vm.documenten.indexOf(vm.documenten.find(item => item.documentId === this.$route.params.documentId)); 
            var indexOfCurrentItem = this.currentDocumentIndex;

            if (indexOfCurrentItem === -1) {
                    return
            }

            this.previous = indexOfCurrentItem === 0 ? 0 : vm.documenten[indexOfCurrentItem - 1].documentId;
            this.next = indexOfCurrentItem + 1 === vm.documenten.length ? 0 : vm.documenten[indexOfCurrentItem + 1].documentId; 
                  
        })
        
        vm.find({
            resource: 'aiinvoicedata',
            id: this.$route.params.documentId
        })

        vm.find({
            resource: 'mltriggers',
            id: -this.$route.params.triggermelding.triggerId
        })
        .then((data) => {
            vm.initializingRegexTab = true;
            vm.disableButton = true;

            vm.commandRegexes = new CommandRegexes(data);
            vm.readCommand = new CommandRegexes(data)

            vm.$nextTick(() => {
                vm.initializingRegexTab = false;
            });                
        })        

        this.getDropdownItems('factuurnummer')
        this.getDropdownItems('factuurdatum')
        this.getDropdownItems('totaalbedrag')
        this.getDropdownItems('subtotaal')
        this.getDropdownItems('btwLaag')
        this.getDropdownItems('btwHoog')
        this.getDropdownItems('kostenNul')
        this.getDropdownItems('kostenVerlegd')
        this.getDropdownItems('kostenLaag')
        this.getDropdownItems('kostenHoog')
    },
    updated(){
        var vm = this;
         if(vm.document.documentId !== this.$route.params.documentId){
            this.currentDocumentIndex = vm.documenten.indexOf(vm.documenten.find(item => item.documentId === this.$route.params.documentId));
            vm.find({
                resource: 'documenten',
                id: this.$route.params.documentId
            })
            .then(() => {
                vm.command.copyTriggermelding(this.$route.params.triggermelding);
                this.loadImage();

                var indexOfCurrentItem = vm.documenten.indexOf(vm.documenten.find(item => item.documentId === this.$route.params.documentId));
                
                if (indexOfCurrentItem === -1) {
                     return
                }

                this.previous = indexOfCurrentItem === 0 ? 0 : vm.documenten[indexOfCurrentItem - 1].documentId;
                this.next = indexOfCurrentItem + 1 === vm.documenten.length ? 0 : vm.documenten[indexOfCurrentItem + 1].documentId;        
            })
        }
    } 
}
</script>
<style>
.edit {
    border: 5px solid #45ad17;
}
.invoice-date {
    z-index: 100!important;
}
.basetriggerdata {
    background-color: rgb(207, 204, 204);
}

/* =========================
   TABBLADEN – HUISSTIJL
   ========================= */

/* Navigatiebalk met tabs */
.tab-nav {
  background-color: #f4f6f5;
  border-bottom: 1px solid #dcdcdc;
  padding: 0.25rem 0.25rem 0;
}

/* Alle tab-knoppen */
.tab-nav .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  margin-right: 0.25rem;
  padding: 0.6rem 1rem;
  font-weight: 600;
  color: #555;
  background-color: transparent;
  transition: background-color 0.15s ease, color 0.15s ease;
}

/* Hover */
.tab-nav .nav-link:hover {
  background-color: #e9f5ee;
  color: #2f2f2f;
}

/* Actieve tab */
.tab-nav .nav-link.tab-active {
  background-color: #ffffff;
  color: #45ad17;
  border-color: #dcdcdc #dcdcdc #ffffff;
  border-top: 3px solid #45ad17;   /* duidelijke themekleur-accent */
  position: relative;
  top: 1px; /* optisch aansluiten op content */
}

/* Contentvlak onder de tabs */
.tab-content-area {
  background-color: #ffffff;
  border: 1px solid #dcdcdc;
  border-top: 0;
  padding: 1.25rem;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

</style>